import axios from 'axios';
import {
    PLAYER_ACTIVITY_FAIL,
    PLAYER_ACTIVITY_REQUEST, PLAYER_ACTIVITY_SUCCESS,
    PLAYER_CREATE_FAIL,
    PLAYER_CREATE_REQUEST,
    PLAYER_CREATE_SUCCESS,
    PLAYER_DELETE_FAIL,
    PLAYER_DELETE_REQUEST,
    PLAYER_DELETE_SUCCESS,
    PLAYER_DETAILS_FAIL,
    PLAYER_DETAILS_REQUEST,
    PLAYER_DETAILS_SUCCESS,
    PLAYER_LIST_FAIL,
    PLAYER_LIST_REQUEST,
    PLAYER_LIST_SUCCESS,
    PLAYER_LOG_DATES_FAIL,
    PLAYER_LOG_DATES_REQUEST,
    PLAYER_LOG_DATES_SUCCESS,
    PLAYER_LOG_FOR_DATE_FAIL,
    PLAYER_LOG_FOR_DATE_REQUEST,
    PLAYER_LOG_FOR_DATE_SUCCESS, PLAYER_RESTART_FAIL, PLAYER_RESTART_REQUEST, PLAYER_RESTART_SUCCESS,
    PLAYER_UPDATE_DETAILS_FAIL,
    PLAYER_UPDATE_DETAILS_REQUEST,
    PLAYER_UPDATE_DETAILS_SUCCESS
} from '../constants/playerConstants';

export const listPlayers = (id, flag) => async (dispatch, getState) => {
    try {
        dispatch({type: PLAYER_LIST_REQUEST});

        const {
            userLogin: {userInfo},
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };
        let url = '/api/players';
        if(userInfo.isAdmin && flag === 'all'){
            url = `/api/players/admin/${id}`
        }
        const {data} = await axios.get(url, config);

        dispatch({type: PLAYER_LIST_SUCCESS, payload: data});
    } catch (error) {
        dispatch({
            type: PLAYER_LIST_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const listPlayerDetails = (id) => async (dispatch, getState) => {
    try {
        dispatch({type: PLAYER_DETAILS_REQUEST});

        const {
            userLogin: {userInfo},
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };
        const {data} = await axios.get(`/api/players/${id}`, config);

        dispatch({type: PLAYER_DETAILS_SUCCESS, payload: data});
    } catch (error) {
        dispatch({
            type: PLAYER_DETAILS_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const updatePlayerDetails = (player) => async (dispatch, getState) => {
    try {
        dispatch({type: PLAYER_UPDATE_DETAILS_REQUEST});

        const {
            userLogin: {userInfo},
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const {data} = await axios.put(`/api/players/${player._id}`, player, config);

        dispatch({type: PLAYER_UPDATE_DETAILS_SUCCESS, payload: data});
    } catch (error) {
        dispatch({
            type: PLAYER_UPDATE_DETAILS_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const createPlayer = (player) => async (dispatch, getState) => {
    try {
        dispatch({type: PLAYER_CREATE_REQUEST});

        const {
            userLogin: {userInfo},
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const {data} = await axios.post(`/api/players`, player, config);

        dispatch({type: PLAYER_CREATE_SUCCESS, payload: data});
    } catch (error) {
        dispatch({
            type: PLAYER_CREATE_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const deletePlayer = (player) => async (dispatch, getState) => {
    try {
        dispatch({type: PLAYER_DELETE_REQUEST});

        const {
            userLogin: {userInfo},
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const {data} = await axios.delete(`/api/players/${player._id}`, config);

        dispatch({type: PLAYER_DELETE_SUCCESS, payload: data});

    } catch (error) {
        dispatch({
            type: PLAYER_DELETE_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const listPlayerLogDates = (id) => async (dispatch, getState) => {
    try {
        dispatch({type: PLAYER_LOG_DATES_REQUEST});

        const {
            userLogin: {userInfo},
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };
        const {data} = await axios.post(`/api/players/logdates`, {"playerId": id}, config);

        dispatch({type: PLAYER_LOG_DATES_SUCCESS, payload: data});
    } catch (error) {
        dispatch({
            type: PLAYER_LOG_DATES_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const listPlayerLogForDate = (id, date) => async (dispatch, getState) => {
    try {
        dispatch({type: PLAYER_LOG_FOR_DATE_REQUEST});

        const {
            userLogin: {userInfo},
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };
        const {data} = await axios.post(`/api/players/logs`, {"playerId": id, "date": date}, config);

        dispatch({type: PLAYER_LOG_FOR_DATE_SUCCESS, payload: data});
    } catch (error) {
        dispatch({
            type: PLAYER_LOG_FOR_DATE_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const restartPlayer = (pin) => async (dispatch, getState) => {
    try {
        dispatch({type: PLAYER_RESTART_REQUEST});
        //console.log('restarting');
        const {
            userLogin: {userInfo},
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };
        const {data} = await axios.post(`/api/restart/${pin}`, {"playerPin": pin}, config);

        //console.log('restart over');
        dispatch({type: PLAYER_RESTART_SUCCESS, payload: data});
    } catch (error) {
        dispatch({
            type: PLAYER_RESTART_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const listPlayerActivities = (id, date) => async (dispatch, getState) => {
    try {
        dispatch({type: PLAYER_ACTIVITY_REQUEST});

        const {
            userLogin: {userInfo},
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        let url = '';

        const activityDate = date != null ? date : '';

        if(userInfo.isAdmin){
            url = `/api/players/admin/activity/${id}?date=${activityDate}`
        }
        const {data} = await axios.get(url, config);

        dispatch({type: PLAYER_ACTIVITY_SUCCESS, payload: data});
    } catch (error) {
        dispatch({
            type: PLAYER_ACTIVITY_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};
